import { MessageCircle, Phone } from "lucide-react";
import { SITE } from "@/lib/site";
import { cn } from "@/lib/utils";

const base = "flex items-center justify-center gap-2 rounded-xl px-4 py-3 text-[15px] font-bold transition-[background-color,transform,box-shadow] hover:-translate-y-0.5 hover:shadow-soft";

export const ContactButtons = ({ prefix, className }) => (
  <div className={cn("grid grid-cols-2 gap-2", className)}>
    <a href={SITE.phoneHref} className={cn(base, "bg-brand-blue text-white hover:bg-brand-blue-dark")} data-testid={`${prefix}-call-button`}>
      <Phone className="h-4 w-4" /> Anrufen
    </a>
    <a
      href={SITE.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(base, "bg-brand-whatsapp text-brand-anthracite hover:bg-[#1fc15c]")}
      data-testid={`${prefix}-whatsapp-button`}
    >
      <MessageCircle className="h-4 w-4" /> WhatsApp
    </a>
  </div>
);
